<div class="popup-wrapper">
  <ng-content select=".inner"></ng-content>
</div>
